import { useTranslation as i18nextUseTranslation } from 'react-i18next';

// @ts-ignore: paraglide is vanilla JS
import * as m from '@klaviyo-mkt/i18n/paraglide/messages';
// @ts-ignore: paraglide is vanilla JS
import { languageTag } from '@klaviyo-mkt/i18n/paraglide/runtime';

/**
 * Used for backwards-compatibility with i18next.
 * If your component will be used with Astro and Gatsby, use this hook.
 * If your component will only be used with Astro, use import * as m from '../paraglide/messages';.
 */
export const useTranslation = () => {
  const { t, i18n } = i18nextUseTranslation();

  if (i18n.isInitialized) {
    return ({
      t,
      i18n: {
        language: i18n.language,
      },
    });
  }

  return ({
    t: (key: string, options?: object) => {
      // eslint-disable-next-line import/namespace
      return m[key](options);
    },
    i18n: {
      language: languageTag(),
    },
  });
};
